var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
const SavingsWithdraw = (_a) => {
    var { color = '#FFFFFF', fill = 'none', width = 24, height = 24 } = _a, props = __rest(_a, ["color", "fill", "width", "height"]);
    return (React.createElement("svg", { width: width, height: height, viewBox: `0 0 ${width} ${height}`, fill: fill, xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M12.666 2C7.14602 2 2.66602 6.48 2.66602 12C2.66602 17.52 7.14602 22 12.666 22C18.186 22 22.666 17.52 22.666 12C22.666 6.48 18.186 2 12.666 2ZM16.196 13.03L13.196 16.03C13.046 16.18 12.856 16.25 12.666 16.25C12.476 16.25 12.286 16.18 12.136 16.03L9.13602 13.03C8.84602 12.74 8.84602 12.26 9.13602 11.97C9.42602 11.68 9.90602 11.68 10.196 11.97L11.916 13.69V8.5C11.916 8.09 12.256 7.75 12.666 7.75C13.076 7.75 13.416 8.09 13.416 8.5V13.69L15.136 11.97C15.426 11.68 15.906 11.68 16.196 11.97C16.486 12.26 16.486 12.74 16.196 13.03Z", fill: color })));
};
export default SavingsWithdraw;
